import Grid from "@mui/material/Grid";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import makeStyles from "@mui/styles/makeStyles";
import styles from 'assets/jss/Scan/scanStyle';
import {styled} from "@mui/material/styles";
import LinearProgress, {linearProgressClasses} from "@mui/material/LinearProgress";
import {scanLevels} from 'helpers/scanLevels'

const useStyles = makeStyles(styles)


const BorderLinearProgress = styled(LinearProgress)(({theme}) => ({
    height: 24,
    width: '100%',
    margin:'0 auto',
    borderRadius: 16,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor:
            theme.palette.grey[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 16,
        backgroundImage:
            'linear-gradient(144deg, rgba(60,192,195,1) 0%, rgba(95,126,192,1) 54%, rgba(117,60,190,1) 100%);',
    },
    [`& .${linearProgressClasses.buffer}`]: {},
}));

const ScanProgress = (props) => {
    const {nfcError, nfcStatus, progressValue} = props
    const classes = useStyles()
    return (
        <>
            {nfcError ? (
                <Grid className={classes.errorContainer}>
                    <Grid item className={classes.root} xs={12}>
                        <ErrorOutlineIcon
                            style={{color: '#d81d5d', fontSize: '35px'}}
                        />
                    </Grid>
                    <Grid item className={classes.root} xs={12}>
                        {nfcStatus === scanLevels.NFC_STARTED ? (
                            <p className={classes.errorMessage}>
                                عدم برقراری ارتباط با nfc دستگاه
                            </p>
                        ) : nfcStatus === scanLevels.NFC_READING_STARTED ? (
                            <p className={classes.errorMessage}>مجددا تلاش کنید</p>
                        ) : nfcStatus === scanLevels.NFC_READING ? (
                            <p className={classes.errorMessage}>
                                اطلاعات به صورت کامل دریافت نشد(مجددا تلاش کنید)
                            </p>
                        ) : nfcStatus === scanLevels.NFC_FINISHED_OK ? (
                            <p className={classes.errorMessage}>دریافت ناموفق اطلاعات</p>
                        ) : nfcStatus === scanLevels.SENDING_TO_SERVER ? (
                            <p className={classes.errorMessage}>
                                مشکل در برقراری ارتباط با شبکه
                                <br/>(لطفا اتصال اینترنت خود را بررسی
                                کنید)
                            </p>
                        ) : (
                            <p className={classes.errorMessage}>مجدد تلاش کنید</p>
                        )}
                    </Grid>
                </Grid>
            ) : (
                <Grid item xs={12} mt='10px'>
                    <BorderLinearProgress variant='determinate' value={progressValue>=100?100:progressValue}/>
                </Grid>
            )}
        </>

    )
}
export default ScanProgress